import React, { useContext,useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {Paper, MenuList, MenuItem, ListItemIcon, ListItemText, List, Collapse, ListItem,Backdrop,CircularProgress } from "@mui/material";
import { eachDeep } from "deepdash-es/standalone";
import ContextMenu from "./ContextMenu";
import { 
  DeleteInboundTemplate,
  NewTemplateWizard,
  NewWorkflowGroup,
  PrintInboundMappingData,
  ReloadInboundTemplate,
  RenameSelectedTemplate,
  CopyInboundTemplate,
  LocalRevisionHistory,
  DeployToServer
} from "./WorkflowGroupActions";
import { newTemplateActions } from "../../redux/slices/newTemplateSlice";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import ErrorModal from "../ItemProperties/Forms/FieldDataValidation/ErrorModal";
import { api } from "../../redux/api";
import ServerRevisionHistory from "./WorkflowGroupActions/ServerRevisionHistory";
import DownloadTemplate from "./WorkflowGroupActions/DownloadTemplate";
import UploadTemplate from "./WorkflowGroupActions/UploadTemplate";

const TEMPLATE_MODALS = {
  MNU_NEW_WF_GROUP: "MNU_NEW_WF_GROUP",
  MNU_NEW_TEM_WIZ: "MNU_NEW_TEM_WIZ",
  BTN_COPY_EXIST_IN_TEM: "BTN_COPY_EXIST_IN_TEM",
  MNU_REN_TEM: "MNU_REN_TEM",
  MNU_DEL_SEL_TEM: "MNU_DEL_SEL_TEM",
  MNU_RELOAD_TEM: "MNU_RELOAD_TEM",
  LBL_EDI_TYPE: "LBL_EDI_TYPE",
  LBL_HL7_TYPE: "LBL_HL7_TYPE",
  LBL_LOCAL_REVISION_HISTORY: "LBL_LOCAL_REVISION_HISTORY",
  MNU_PRINT_MAP_RPT: "MNU_PRINT_MAP_RPT",
  LBL_GENERATE_997: "LBL_GENERATE_997",
  LBL_SERVER_REV:"LBL_SERVER_REV",
  LBL_DOWNLOAD_TEMP:"LBL_DOWNLOAD_TEMP",
  LBL_UPLOAD_TEMP:"LBL_UPLOAD_TEMP",
  DEPLOY_TO_SERVER:"DEPLOY_TO_SERVER",
};


function WftContextMenu({ targetId }) {
  const { t } = useTranslation();
  const [templateModal, setTemplateModal] = useState(null);
  const [subMenu, setSubMenu] = React.useState(false)
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const handleTemplateModal = (val) => () => setTemplateModal(val);
  const dispatch = useDispatch()
  const { account } = useSelector((state) => state.queryParams);
  const selectedNode = useSelector(state => state.treeData[parentScreen].leftTree.tree.body.selectedNode);
  const { currentScreen } = useSelector(state => state.treeData)
  const templateHeader = rightTree.tree.templateHeader
  const onOpenMenu = (value) => () => setSubMenu(value);
  const [HL7ModalTitle, setHL7ModalTitle] = useState('');
  const [HL7ModalMessage, setHL7ModalMessage] = useState('');
  const [hl7Modal, setHl7Modal] = useState(false)
  const [EDIModalTitle, setEDIModalTitle] = useState('');
  const [EDIModalMessage, setEDIModalMessage] = useState('');
  const [openNTWModal, setOpenNTWMdal] = useState(false)
  const [ediModal, setEdiModal] = useState(false);
  const [path, setPath] = useState('');
  const datatype = templateHeader?.FILETYPE;
  const [isLoading,setIsLoading] = useState(false);
  const [isEdiLoading, setIsEdiLoading] = useState(false);
  const handleNewTemplate = () => {
    setOpenNTWMdal(true);
    // dispatch(newTemplateActions.setModalOpen(true));
  }

  const findEDIPath = (lists) => {
    const edi = lists?.filter((list) => list.path === 'EDI');
    let path = '';
    eachDeep(edi, (obj) => {
      if (obj.release_key === templateHeader.FILETYPE_VERSION) {
        path = obj?.path
      }
    });
    return path;
  }

  const copyFilePath = async () => {
    setIsEdiLoading(true);
    let path = null;
    
    try {
      const response = await dispatch(api.endpoints.getRepositoryTemplates.initiate({
        account,
        template_type: 'INBOUND'
      },{forceRefetch: true}))
  
      if (response?.data?.current_state === 'SUCCESS') {
        path = findEDIPath(response.data.data);
        handleEDI(path);
      } else {
        throw new Error(response.message || t("BOX_MSG_GENERAL_ERROR"));
      }
    } catch (error) {
      setEDIModalTitle(t('ERROR'));
      setEDIModalMessage(error.message || t("BOX_MSG_GENERAL_ERROR"));
      setEdiModal(true);
    } finally {
      setIsEdiLoading(false);
    }
  
    return path; 
  };
  
  const handleEDI = async (path) => {
    try {
      const response = await dispatch(
        api.endpoints.addNewEDI997Template.initiate({
          account,
          newTemplateName: selectedNode.title,
          workflowGroup: selectedNode.workflowGroup,
          file_type: 'SEF',
          is_inbound: true,
          path: encodeURIComponent(path),
          release_key: templateHeader.FILETYPE_VERSION,
          sef_edi_set: templateHeader.TXN_SET_TYPE,
          is_repo: true,
          generate_997: true
        },{forceRefetch: true})
      )
      
      const current_state = response?.data?.current_state;
      
      if (current_state === 'SUCCESS') {
        setEDIModalTitle(current_state);
        setEDIModalMessage(response?.data?.message);
        setEdiModal(true);
        
        dispatch(api.endpoints.getOutboundTemplateList.initiate(
          { account },
          { subscribe: false }
        ));
      } else {
        throw new Error(response.message || response.data.message || t("BOX_MSG_GENERAL_ERROR"));
      }
      
    } catch (error) {
      setEDIModalTitle(t('ERROR'));
      setEDIModalMessage(error.message  || t("BOX_MSG_GENERAL_ERROR"));
      setEdiModal(true);
    }
  };
  

  const handleHl7ACK = () => {
    setIsLoading(true)
    try{
      dispatch(
        api.endpoints.addNewInboundTemplate.initiate({
          account,
          newTemplateName: selectedNode.title,
          workflowGroup: selectedNode.workflowGroup,
          file_type: "HL7",
          is_inbound: true,
          release_key: templateHeader.FILETYPE_VERSION,
          generate_ack: true,
        })
      ).then((response) => {
        if (response?.data) {
          const current_state = response?.data?.current_state;
          setHL7ModalTitle(current_state);
          setHL7ModalMessage(response.data.message);
          setHl7Modal(true);
          if (current_state === "SUCCESS") {
            setIsLoading(false);
            dispatch(
              api.endpoints.getOutboundTemplateList.initiate(
                { account },
                { subscribe: false, forceRefetch: true }
              )
            );
          }
        } else {
          setTimeout(() => {
            setIsLoading(false);
            setHL7ModalTitle(t("ERROR"));
            setHL7ModalMessage(t("BOX_MSG_GENERAL_ERROR"));
            setHl7Modal(true);
          }, 10);
        }
      });
  } catch(error){
    setIsLoading(false)
  }

  };
  return (
    <>
      <ContextMenu targetId={targetId}>
        <Paper sx={{ minWidth: "17rem"}}>
          <MenuList dense>
            <MenuItem
              name={t("MNU_NEW_WF_GROUP")}
              onClick={handleTemplateModal(TEMPLATE_MODALS.MNU_NEW_WF_GROUP)}>
              <ListItemIcon><span className={"RECORD"}></span></ListItemIcon>
              <ListItemText>{t("MNU_NEW_WF_GROUP")}</ListItemText>
            </MenuItem>
            <MenuItem
              name={t("MNU_NEW_TEM_WIZ")}
              onClick={handleNewTemplate}>
              <ListItemIcon><span className={"WIZARD"}></span></ListItemIcon>
              <ListItemText>{t("MNU_NEW_TEM_WIZ")}</ListItemText>
            </MenuItem>
            <MenuItem
              name={t("BTN_COPY_EXIST_IN_TEM")}
              onClick={handleTemplateModal(TEMPLATE_MODALS.BTN_COPY_EXIST_IN_TEM)}>
              <ListItemIcon><span className={"COPY"}></span></ListItemIcon>
              <ListItemText>{t("BTN_COPY_EXIST_IN_TEM")}</ListItemText>
            </MenuItem>
            <MenuItem
              name={t("MNU_REN_TEM")}
              onClick={handleTemplateModal(TEMPLATE_MODALS.MNU_REN_TEM)}>
              <ListItemIcon><span className={"RENAME_INBOUND"}></span></ListItemIcon>
              <ListItemText>{t("MNU_REN_TEM")}</ListItemText>
            </MenuItem>
            <MenuItem
              name={t("MNU_DEL_SEL_TEM")}
              onClick={handleTemplateModal(TEMPLATE_MODALS.MNU_DEL_SEL_TEM)}>
              <ListItemIcon><span className={"DELETE_INBOUND"}></span></ListItemIcon>
              <ListItemText>{t("MNU_DEL_SEL_TEM")}</ListItemText>
            </MenuItem>
            <MenuItem
              name={t("MNU_RELOAD_TEM")}
              onClick={handleTemplateModal(TEMPLATE_MODALS.MNU_RELOAD_TEM)}>
              <ListItemIcon><span className={"RELOAD_INBOUND"}></span></ListItemIcon>
              <ListItemText>{t("MNU_RELOAD_TEM")}</ListItemText>
            </MenuItem>
            <MenuItem
              name={t("LBL_LOCAL_USER_REVISION_HISTORY")}
              onClick={handleTemplateModal(TEMPLATE_MODALS.LBL_LOCAL_REVISION_HISTORY)}>
              <ListItemIcon><span className={"REVISION_HISTORY"}></span></ListItemIcon>
              <ListItemText>{t("LBL_LOCAL_USER_REVISION_HISTORY")}</ListItemText>
            </MenuItem>
            <MenuItem
              name={t("LBL_SERVER_REV")}
              onClick={handleTemplateModal(TEMPLATE_MODALS.LBL_SERVER_REV)}>
              <ListItemIcon><span className={"REVISION_HISTORY"}></span></ListItemIcon>
              <ListItemText>{t("LBL_SERVER_REV")}</ListItemText>
            </MenuItem>
            {(datatype === "EDI" && currentScreen === "inbound" && templateHeader?.SUB_TYPE === "EDI X12") && (
              <MenuItem onClick={copyFilePath}>
                <ListItemIcon>
                  <span className="EDI_HL7"></span>
                </ListItemIcon>
                <ListItemText>
                  {t("LBL_EDI_TYPE")} - {t("LBL_GENERATE_997")}
                </ListItemText>
              </MenuItem>
            )}
            {(datatype === "HL7" && currentScreen === "inbound") && (
              <MenuItem onClick={handleHl7ACK}>
                <ListItemIcon>
                  <span className="EDI_HL7"></span>
                </ListItemIcon>
                <ListItemText>
                  {t("LBL_HL7_TYPE")} - {t("LBL_GENERATE_HL7_ACK")}
                </ListItemText>
              </MenuItem>
            )}
            {/* Option removed for now as per BG-10195 */}
            {/* <MenuItem
              name={t("MNU_PRINT_MAP_RPT")}
              onClick={handleTemplateModal(TEMPLATE_MODALS.MNU_PRINT_MAP_RPT)}>
              <ListItemIcon><span className={"PRINTER"}></span></ListItemIcon>
              <ListItemText>
                {t("MNU_PRINT_MAP_RPT")}
              </ListItemText>
            </MenuItem> */}
             <MenuItem
              onClick={handleTemplateModal(TEMPLATE_MODALS.LBL_UPLOAD_TEMP)}>
              <ListItemIcon>
                <span className="UPLOAD_TEMPLATE"></span>
              </ListItemIcon>
              <ListItemText>{t("LBL_UPLOAD_TEMP")}</ListItemText>
            </MenuItem>
            <MenuItem
              onClick={handleTemplateModal(TEMPLATE_MODALS.LBL_DOWNLOAD_TEMP)}>
              <ListItemIcon>
                <span className="DOWNLOAD_TEMPLATE"></span>
              </ListItemIcon>
              <ListItemText>{t("LBL_DOWNLOAD_TEMP")}</ListItemText>
            </MenuItem>
            {/* Deploy to Server - Show for userspace-only files and files that exist in both locations */}
            {(selectedNode?.location === 'userspace' || selectedNode?.location === 'both') && (
              <MenuItem
                name={t("DEPLOY_TO_SERVER")}
                onClick={handleTemplateModal(TEMPLATE_MODALS.DEPLOY_TO_SERVER)}>
                <ListItemIcon>
                  <span className="SERVER"></span>
                </ListItemIcon>
                <ListItemText>{t("DEPLOY_TO_SERVER")}</ListItemText>
              </MenuItem>
            )}
          </MenuList>
        </Paper>
      </ContextMenu>
      
      
      <DeleteInboundTemplate
        openModal={templateModal === TEMPLATE_MODALS.MNU_DEL_SEL_TEM}
        toggle={handleTemplateModal(null)}
      />
      <RenameSelectedTemplate
        openModal={templateModal === TEMPLATE_MODALS.MNU_REN_TEM}
        toggle={handleTemplateModal(null)}
      />
      <ReloadInboundTemplate
        openModal={templateModal === TEMPLATE_MODALS.MNU_RELOAD_TEM}
        toggle={handleTemplateModal(null)}
      />
      {/* <PrintInboundMappingData
        openModal={templateModal === TEMPLATE_MODALS.MNU_PRINT_MAP_RPT}
        toggle={handleTemplateModal(null)}
      /> */}
      {openNTWModal && (
        <NewTemplateWizard modalOpen={openNTWModal} toggle={() => setOpenNTWMdal(false)} />
      )}
      <NewWorkflowGroup
        modalOpen={templateModal === TEMPLATE_MODALS.MNU_NEW_WF_GROUP}
        toggle={handleTemplateModal(null)}
      />
      <CopyInboundTemplate
        openModal={templateModal === TEMPLATE_MODALS.BTN_COPY_EXIST_IN_TEM}
        toggle={handleTemplateModal(null)}
      />
      <LocalRevisionHistory
        openModal={templateModal === TEMPLATE_MODALS.LBL_LOCAL_REVISION_HISTORY}
        toggle={handleTemplateModal(null)}
      />
      <ServerRevisionHistory
        openModal={templateModal === TEMPLATE_MODALS.LBL_SERVER_REV}
        toggle={handleTemplateModal(null)}
      />
      {templateModal === TEMPLATE_MODALS.LBL_DOWNLOAD_TEMP && (
        <DownloadTemplate
          open={templateModal === TEMPLATE_MODALS.LBL_DOWNLOAD_TEMP}
          toggle={handleTemplateModal(null)}
        />
      )}
      {templateModal === TEMPLATE_MODALS.LBL_UPLOAD_TEMP && (
        <UploadTemplate open={templateModal === TEMPLATE_MODALS.LBL_UPLOAD_TEMP} toggle={handleTemplateModal(null)} />
      )}
      <DeployToServer
        open={templateModal === TEMPLATE_MODALS.DEPLOY_TO_SERVER}
        toggle={handleTemplateModal(null)}
      />
      {hl7Modal && (
        <ErrorModal
          errorModal={hl7Modal}
          errorMessage={HL7ModalMessage}
          errorType={HL7ModalTitle}
          handleErrorModal={() => setHl7Modal(false)}
        />
      )}
      <Backdrop
        open={isLoading || isEdiLoading}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {ediModal && <ErrorModal
        errorModal={ediModal}
        errorMessage={EDIModalMessage}
        errorType={EDIModalTitle}
        handleErrorModal={() => setEdiModal(false)}
      />}
    </>
  );
}

export default WftContextMenu;
